/**
 * SEO 配置 - models (Português)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - Gerador de vídeo IA principal | WeryAI',
        description: 'Google Veo 3.1: Modelo de vídeo IA principal com áudio nativo e controle de quadros.',
        keywords: 'Google Veo 3.1, vídeo IA, gerador de vídeo, WeryAI',
    },
    veo_3: {
        title: 'Google Veo 3 - Geração de vídeo IA de alta qualidade | WeryAI',
        description: 'Experimente Veo 3 no WeryAI. Resultados de alta qualidade.',
        keywords: 'Veo 3, Google Veo, vídeo IA, WeryAI',
    },
    veo_3_fast: {
        title: 'Google Veo 3 Fast - Geração de vídeo IA ultrarrápida | WeryAI',
        description: 'Experimente Veo 3 Fast no WeryAI. Resultados rápidos e de alta qualidade.',
        keywords: 'Veo 3 Fast, vídeo IA rápido, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 - Gerador de vídeo IA realista | WeryAI',
        description: 'Experimente Sora 2 no WeryAI. Resultados de alta qualidade.',
        keywords: 'Sora 2, OpenAI Sora, vídeo IA, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 - Gerador de vídeo IA | WeryAI',
        description: 'Experimente WeryAI Video 1.0 para criar vídeos IA cinematográficos.',
        keywords: 'WeryAI Video 1.0, vídeo IA, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 - Gerador de imagens IA | WeryAI',
        description: 'Experimente WeryAI Image 2.0 para gerar imagens de qualidade de estúdio.',
        keywords: 'WeryAI Image 2.0, imagens IA, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 Gerador de Imagens - xAI | WeryAI',
        description: 'Experimente Grok-2 da xAI no WeryAI.',
        keywords: 'Grok-2, xAI, imagens IA, WeryAI',
    },
    kling_ai: {
        title: 'Kling AI - Gerador de vídeo IA cinematográfico | WeryAI',
        description: 'Experimente Kling AI no WeryAI. Resultados de alta qualidade.',
        keywords: 'Kling AI, vídeo IA, WeryAI',
    },
    runway_ai: {
        title: 'Runway AI - Gerador e editor de vídeo IA | WeryAI',
        description: 'Experimente Runway AI no WeryAI. Resultados de alta qualidade.',
        keywords: 'Runway AI, vídeo IA, WeryAI',
    },
    hailuo_23: {
        title: 'Hailuo 2.3 - Gerador de vídeo IA | WeryAI',
        description: 'Experimente Hailuo 2.3 no WeryAI. Resultados de alta qualidade.',
        keywords: 'Hailuo 2.3, vídeo IA, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI - Gerador de vídeo IA avançado | WeryAI',
        description: 'Experimente Hailuo AI no WeryAI. Resultados de alta qualidade.',
        keywords: 'Hailuo AI, vídeo IA, WeryAI',
    },
    pika_2_2: {
        title: 'Pika 2.2 - Gerador de animação IA | WeryAI',
        description: 'Experimente Pika 2.2 no WeryAI. Resultados de alta qualidade.',
        keywords: 'Pika 2.2, animação IA, WeryAI',
    },
    seedance: {
        title: 'Seedance - Gerador de vídeo de dança e movimento IA | WeryAI',
        description: 'Experimente Seedance no WeryAI. Resultados realistas e profissionais.',
        keywords: 'Seedance, vídeo IA, WeryAI',
    },
    wan_ai: '',
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - Geração de imagens Google Gemini 3.0 Pro | WeryAI',
        description: 'Modelo de imagem IA baseado em raciocínio. Qualidade 4K ultra-realista e tipografia perfeita.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, geração de imagens IA, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - Desenho ultrarrápido Gemini 2.5 Flash | WeryAI',
        description: 'Gerador de imagens IA ultrarrápido do Google DeepMind. Suporta edição em linguagem natural.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, desenho rápido, WeryAI',
    },
    image_flux: {
        title: 'FLUX AI Gerador de Imagens - Modelo de código aberto | WeryAI',
        description: 'FLUX desenvolvido pela equipe do Stable Diffusion. Qualidade visual excepcional.',
        keywords: 'FLUX, IA, geração de imagens, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - Melhoria profissional de desenho IA | WeryAI',
        description: 'FLUX.1 Pro e Max com renderização de texto aprimorada e consistência de personagens.',
        keywords: 'FLUX Kontext, FLUX Pro, FLUX Max, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - Modelo de difusão texto para imagem | WeryAI',
        description: 'Crie imagens fotorrealistas, artísticas e abstratas com Google Imagen 4.',
        keywords: 'Imagen 4, Google AI, difusão, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image - Modelo de renderização de texto Alibaba | WeryAI',
        description: 'Modelo de imagem IA da Alibaba para renderização de texto multilíngue.',
        keywords: 'Qwen Image, Alibaba, renderização de texto, WeryAI',
    },
    image_wan_ai: {
        title: 'Wan 2.5 Geração de imagens - Modelo de alta fidelidade Alibaba | WeryAI',
        description: 'Wan 2.5 com seguimento preciso de prompts e renderização fotográfica.',
        keywords: 'Wan AI, Wan 2.5, geração de imagens, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - Modelo de desenho 4K em lote ByteDance | WeryAI',
        description: 'Modelo de desenho ultrarrápido da ByteDance com processamento em lote.',
        keywords: 'Seedream, ByteDance, desenho 4K, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - Modelo de criação de imagens IA ByteDance | WeryAI',
        description: 'Dreamina 4.0 para conversão de esboço em imagem e transferência de estilo.',
        keywords: 'Dreamina 4.0, ByteDance, criação de imagens IA, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - Modelo Principal de Geração de Imagens IA da ByteDance | WeryAI',
        description: 'Seedream 4.5 é o mais recente modelo principal de imagem IA da ByteDance, focado em renderização tipográfica precisa e fusão multi-imagem com saída 4K ultra HD. Experimente grátis no WeryAI.',
        keywords: 'Seedream 4.5, geração de imagens IA, renderização tipográfica, fusão de imagens, ByteDance, qualidade 4K, WeryAI',
    },
    image_midjourney: {
        title: 'Midjourney - Geração de imagens flexível, detalhada e vibrante | WeryAI',
        description: 'Midjourney é um modelo de imagem IA principal de um laboratório de pesquisa independente, renomado por sua estética artística. Experimente grátis no WeryAI.',
        keywords: 'Midjourney, geração de imagens IA, criação artística, qualidade de iluminação, renderização de texto, retratos hiperrealistas, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 Gerador de Vídeo IA - Crie Vídeos Cinematográficos | WeryAI',
        description: 'Crie vídeos impressionantes com Runway Gen-4.5 no WeryAI. Arquitetura híbrida autorregressiva-difusão para simulação física precisa e consistência temporal.',
        keywords: 'Runway Gen-4.5, gerador de vídeo IA, vídeo IA cinematográfico, simulação física, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro Gerador de Vídeo IA - Criação de Vídeo de Alta Qualidade | WeryAI',
        description: 'Gere vídeos de alta qualidade com Kling 2.6 Pro no WeryAI. Geração audiovisual nativa, qualidade cinematográfica 1080p, excelente aderência a prompts.',
        keywords: 'Kling 2.6 Pro, gerador de vídeo IA, vídeo IA de alta qualidade, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Gerador de Vídeo - Controle de câmera preciso e orientação de frames | WeryAI',
        description: 'Gere vídeos IA cinematográficos com Dreamina 3.0 (Jimeng 3.0) no WeryAI. Controle preciso de frames início/fim, movimentos de câmera profissionais e geração de vídeo 1080p de alta dinâmica.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, gerador de vídeo IA, controle de câmera, frames início fim, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 Gerador de Vídeo IA - Geração de Vídeo Criativa | WeryAI',
        description: 'Liberte sua criatividade no WeryAI com o gerador de vídeo IA Kling O1. Perfeito para gerar conteúdo de vídeo imaginativo e único.',
        keywords: 'Kling O1, gerador de vídeo IA, vídeo IA criativo, Kling AI, WeryAI',
    },
}
